export default __webpack_public_path__ + "static/media/handycap03-1.a6a80588.png";